"use client";

import { useEffect, useState } from "react";

/** Barra di avanzamento lettura basata sullo scroll dentro l'elemento target. */
export function ReadingProgress({ targetId }: { targetId: string }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const el = document.getElementById(targetId);
    if (!el) return;

    let raf = 0;
    const update = () => {
      raf = 0;
      const rect = el.getBoundingClientRect();
      const total = rect.height - window.innerHeight;
      if (total <= 0) {
        // Articolo piu` corto della viewport: niente da scorrere.
        setProgress(0);
        return;
      }
      const scrolled = Math.min(Math.max(-rect.top, 0), total);
      setProgress(scrolled / total);
    };
    const onScroll = () => {
      if (!raf) raf = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (raf) window.cancelAnimationFrame(raf);
    };
  }, [targetId]);

  return (
    <div className="fixed left-0 right-0 top-0 z-[10025] h-[2px] bg-transparent">
      <div
        className="h-full origin-left bg-gradient-to-r from-primary via-accent to-primary"
        style={{ transform: `scaleX(${progress})` }}
      />
    </div>
  );
}
